import { axios } from '@/lib/axios';

export const getCorpOrders = async (id: number) => {
    const { data } = await axios.get(`v1/get-corporation-orders/${id}`);
    return data.orders;
};